import { render, staticRenderFns } from "./PartnerMessageTable.vue?vue&type=template&id=0f05f786&"
import script from "./PartnerMessageTable.vue?vue&type=script&lang=ts&"
export * from "./PartnerMessageTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports